import React from 'react';

export function LimitContentWidthNormalColumnFormatter(cellContent, classNames = 'font-size-lg', style) {
  return (
    <div
      title={cellContent}
      className={`${classNames} text-dark-75 font-weight-normal d-block text-nowrap limited-content-width-column`}
      style={style}
    >
      {cellContent}
    </div>
  );
}
